export default {
  'bank-of-america': true,
  clydesdale: true,
  elo: true,
  maestro: true,
  regions: true,
  virgin: true,
  banorte: true,
  cofifis: true,
  'fifth-third': true,
  mastercard: true,
  santander: true,
  'visa-electron': true,
  '4etoiles': true,
  barclays: true,
  cofinoga: true,
  hiper: true,
  nationwide: true,
  solo: true,
  visa: true,
  'american-express': true,
  'capital-one': true,
  'cooperative-bank': true,
  hipercard: true,
  natwest: true,
  'standard-chartered': true,
  'wells-fargo': true,
  aura: true,
  cb: true,
  credit: true,
  holding: true,
  'payment-card': true,
  star: true,
  yorkshire: true,
  aurire: true,
  cetelem: true,
  delta: true,
  hsbc: true,
  'paypal-balance': true,
  suntrust: true,
  aurora: true,
  'jp-morgan-chase-bank-na': true,
  chase: true,
  diners: true,
  huntington: true,
  'paypal-credit': true,
  switch: true,
  banamex: true,
  'china-union-pay': true,
  discover: true,
  jcb: true,
  pnc: true,
  td: true,
  bancomer: true,
  kiwi: true,
  postepay: true,
  us: true,
  'bank-account': true,
  citi: true,
  ec: true,
  lloyds: true,
  rbs: true,
  usaa: true,
  'paypal-mastercard': true,
  'ebay-mastercard': true,
  'smart-connect': true,
  'japan-post-bank': true,
  'sumitomo-mitsui-banking-corp': true,
  'mizuho-bank': true,
  'mufg-bank': true,
  'resona-bank': true,
  'saitama-resona-bank': true,
}
